import React, { HTMLAttributes } from 'react';
import { Box, Typography, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

type Props = HTMLAttributes<HTMLDivElement> & {
  countryCount: number;
  universityCount: number;
};

const headerHeight: number = 89;

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    alignItems: 'center',
    backgroundColor: 'rgba(74,74,74,0.8)',
    display: 'flex',
    justifyContent: 'space-between',
    height: '10vh',
    left: 0,
    maxHeight: headerHeight,
    paddingLeft: 16,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 1,
  },
  logo: {
    backgroundImage: `url('/outbound/images/logo.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    cursor: 'pointer',
    height: '100%',
    maxHeight: 59,
    width: 235,
  },
  number: {
    marginRight: 8,
  },
  summaryBox: {
    color: 'white',
    display: 'flex',
    padding: 8,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

const Header: React.FC<Props> = ({
  countryCount,
  universityCount,
  ...props
}) => {
  const { header, logo, number, summaryBox } = useStyles();
  return (
    <div className={header}>
      <div className={logo} onClick={() => window.location.reload()} />
      <div className={clsx(props.className, summaryBox)}>
        <Box display="flex" alignItems="baseline" mr={2}>
          <Typography className={number} variant="h3" color="secondary">
            {universityCount}
          </Typography>
          <Typography variant="caption">Universities</Typography>
        </Box>
        <Box display="flex" alignItems="baseline" mr={2}>
          <Typography className={number} variant="h3">
            {countryCount}
          </Typography>
          <Typography variant="caption">Countries</Typography>
        </Box>
      </div>
    </div>
  );
};

export default Header;
